module.exports = __webpack_public_path__ + "img/guide-icon3.db643a7b.png";